module.exports = __webpack_public_path__ + "img/catalogDoor1.png?e0c804117753f50066022d7f1c344bc9";